import { Flex } from "@qws-org/ui-kit";
import type { FC, PropsWithChildren } from "react";

import type { SecondaryLayoutData } from "~/core/types";
import { SecondaryLayoutFooter } from "~/widgets/secondary-layout-footer";
import { SecondaryLayoutHeader } from "~/widgets/secondary-layout-header";
import { SecondaryLayoutNotification } from "~/widgets/secondary-layout-notification";

export type SecondaryLayoutProps = {
  data: SecondaryLayoutData;
};
/**
 *  Layout для приложения (Footer + Header) заполняются из коллекции secondary_layout
 *  может быть переназначен для определенной страницы
 */
export const SecondaryLayout: FC<PropsWithChildren<SecondaryLayoutProps>> = ({
  data,
  children,
}) => {
  return (
    <>
      <Flex
        minHeight="100vh"
        flexDirection="column"
        justify="space-between"
        p={{ py: 56 }}
        d={{ p: { pb: 0 } }}
      >
        <SecondaryLayoutHeader data={data} />
        <main>{children}</main>

        <SecondaryLayoutFooter data={data} />

        <SecondaryLayoutNotification data={data} />
      </Flex>
    </>
  );
};
